import { array, number, object, string } from "yup";

export const ReservationSchema = object().shape({
  // The tickets' email is who the booking belongs to. yup applies trim and
  // lowercase before the tests and yupResolver hands onSubmit the cast value,
  // so a padded or recapitalised entry is saved normalised, and an emptied
  // field (or one loaded as null) is stopped here instead of being posted.
  email: string()
    .nullable()
    .trim()
    .lowercase()
    .email("Formati duhet të jetë e-mail")
    .required("Shkruani e-mail adresen"),
  roundWayTicketDetails: array().of(
    object().shape({
      tripId: string().required("Vendos TripId!").typeError("Vendos TripId!")
    })
  ),
  oneWayTicketDetails: array().of(
    object().shape({
      tripId: string().required("Vendos TripId!").typeError("Vendos TripId!")
    })
  ),
  refundAmount: number().nullable().optional()
});
